import React from 'react'
import { PhoneFilled } from '@ant-design/icons'
import { Color } from '../../../../Common/Color'
import { PHONE_HREF, PHONE_NUMBER } from '../../../../Common/Common'

export default function TabletAssistancePhone ({ fontSize }) {
  return (
    <div style={{
      textAlign: 'center',
      color: Color.green,
      fontSize,
      fontWeight: 'bold'
    }}>
      <div className='assistance-phone' style={{
        '--backgroundColor': Color.green,
        '--color': Color.white
      }}>
        <PhoneFilled style={{ marginRight: '5px' }}/><a style={{ color: 'white' }} href={PHONE_HREF}>{PHONE_NUMBER}</a>
      </div>
    </div>
  )
}
